import { gql } from "@apollo/client";

const schema = {
  get: {
    name: 'paymentType',
    serviceName: 'auth',
    query: gql`
      query paymentType($ids: [String]) {
        paymentType(ids: $ids) {
          data {
            title
            details
          }
        }
      }
    `,
  },
  update: {
    name: 'updatePaymentType',
    serviceName: 'admin',
    query: gql`
      mutation updatePaymentType($ids: [String]!, $title: String, $details: String) {
        updatePaymentType(ids: $ids, title: $title, details: $details) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
